import script from "./PolitiqueConfidentialite.vue?vue&type=script&setup=true&lang=js"
export * from "./PolitiqueConfidentialite.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__